import { calculateOverviews } from "./validate_report_and_overview"

export  function report_overviews(reports, users){
    const report_overviews = []
    for (const user of users){
        const live_releases = user.releases;
        const upcs = live_releases.map((release) => String(release.upc))
        const user_payout_percentage = (user.payout_percentage || 0) / 100
        const total_prices = reports.filter((report) => report.UPC && upcs.includes(String(report.UPC).replace(/'/g, '')))
        console.log(total_prices.length, "total_prices")
        console.log("live release", live_releases);
        if(total_prices.length > 0){
            const report_overview = calculateOverviews(total_prices,user, live_releases);
            report_overviews.push({...report_overview, month_year: total_prices[0]['Statement Period'], user_profile_id: user.user_id})
        }
    }
    return report_overviews
}